/* Wirtschaftsfakten Theme JS */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-drawer-open]');
    const closeBtn = e.target.closest('[data-drawer-close]');
    const drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;

    if (openBtn) {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    if (closeBtn || e.target === drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ---------- Mobile sub-menu toggle ---------- */
  document.querySelectorAll('[data-mobile-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const sub = btn.nextElementSibling;
      if (sub) sub.style.display = (sub.style.display === 'block') ? 'none' : 'block';
    });
  });

  /* ---------- Slider arrows (collection + video) ---------- */
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    const track = slider.querySelector('[data-slider-track]');
    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    if (!track) return;
    const step = function () { return track.clientWidth * 0.8; };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(),  behavior: 'smooth' }); });
  });

  /* ---------- Video slider: play on hover, pause on leave ---------- */
  document.querySelectorAll('.video-slider__item video').forEach(function (v) {
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'metadata');
    const item = v.closest('.video-slider__item');
    if (!item) return;
    item.addEventListener('mouseenter', function () {
      try { v.play(); } catch (e) {}
    });
    item.addEventListener('mouseleave', function () {
      v.pause();
      try { v.currentTime = 0; } catch (e) {}
    });
    // On mobile: play when scrolled into view
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) {
            try { v.play(); } catch (e) {}
          } else {
            v.pause();
          }
        });
      }, { threshold: [0, 0.6, 1] });
      io.observe(item);
    }
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) main.src = thumb.dataset.full || thumb.src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Ajax add to cart ---------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId;
    if (!id) return;
    const original = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      const count = document.querySelector('[data-cart-count]');
      if (count) count.textContent = cart.item_count;
      if (window.wsfCartDrawer) {
        btn.textContent = original;
        btn.disabled = false;
        window.wsfCartDrawer.open();
        return;
      }
      btn.textContent = 'Hinzugefügt';
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400);
    })
    .catch(function () {
      btn.textContent = original;
      btn.disabled = false;
    });
  });
})();
